module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00259.7d056320.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00259.png
// module id = 989
// module chunks = 0